import React, { Component } from 'react';
import '../css/common.css';
import '../css/add_item.css';
import CircleMinus from '../images/minus.png';
import CirclePlus from '../images/add.png';

class AddItemRow extends Component {

    constructor(props) {
        super(props);

        this.state = {item: this.props.item, selected: false}
    }

    itemSelected() {
        this.setState({selected : !this.state.selected});
        this.props.itemSelected(this.state.item);
    }

    itemRemoved() {
        this.setState({selected : !this.state.selected});
        this.props.itemRemoved(this.state.item);
    }

    async qtyChanged(evt) {
        evt.persist();

        var n = parseFloat(evt.target.value);
        if (isNaN(n)) { n = ''; }

        await this.setState(prevState => ({
            item: {                   
                ...prevState.item,   
                Quantity: n
            }
        }));
        this.props.itemChanged(this.state.item);
    }

    addSelectedItemFields() {
        return (
            <div id="divSelectedFields">
                <div id="divAddItemQtySection">
                    <div>Qty</div>
                    <input 
                        id="inpQty"
                        type="number"
                        defaultValue={this.state.item.Quantity} 
                        onBlur={this.qtyChanged.bind(this)}
                    />
                </div>
                <div id="divMeasureSection">
                    <div>Measure</div>
                    <select id="cbxMeas">
                        <option value="cup(s)">cups</option>
                        <option value="tsp">tsp</option>
                        <option value="tbsp">tbsp</option>
                    </select>
                </div>
                <div id="divAddItemRowImgArea">
                    <img 
                        className="imgAddItemRowMinus"
                        style={{width: 20, height: 20}}
                        src={CircleMinus}
                        alt="" 
                        title="Remove" 
                        onClick={this.itemRemoved.bind(this)}
                        />
                </div>
            </div>
        )
    }

    addUnSelectedItemFields() {
        return (
            <div id="divEditBtn">
                <img 
                    className="imgAddItemRowCheck"
                    onClick={this.itemSelected.bind(this)}
                    style={{width: 20, height: 20}}
                    src={CirclePlus}
                    alt="" 
                    title="Add Item" 
                />

            </div>
        )
    }

    render() {
        return (
            <div 
                id="divAddItemRowMain"
                className={this.props.evenRow ? null : 'ultra-ultra-light-bk'}
            >
                <div id="divAddItemRowNameArea">{this.props.item.Item_Name}</div>                
                <div>
                    {
                        this.state.selected ? this.addSelectedItemFields() : this.addUnSelectedItemFields()
                    }
                </div>
            </div>
        );
    }
};

export default AddItemRow;


// WEBPACK FOOTER //
// ./src/components/add_item_row.js